import React from 'react';
import PropTypes from 'prop-types';
import AdvertisementCard from './components/AdvertisementCard';
import {
  ADVERTISEMENT_PARTNERS,
  ADVERTISEMENT_PLACEMENTS,
  ADVERTISEMENT_VIEWS,
  advertisementData,
} from './data';
import style from './style.scss';

const AdvertisementAffiliateTileList = ({view, placement, partners}) => {
  const visiblePartners = ADVERTISEMENT_PARTNERS.filter(
    partner =>
      partners.includes(partner) &&
      advertisementData[partner].placementLinks[placement],
  );

  if (visiblePartners.length === 0) return null;

  if (visiblePartners.length === 1) {
    return (
      <div className={style.single}>
        <AdvertisementCard
          view={view}
          placement={placement}
          partner={visiblePartners[0]}
          isBanner
        />
      </div>
    );
  }

  return (
    <div className={style.list}>
      {visiblePartners.map(partner => (
        <AdvertisementCard
          key={partner}
          view={view}
          placement={placement}
          partner={partner}
        />
      ))}
    </div>
  );
};

AdvertisementAffiliateTileList.propTypes = {
  partners: PropTypes.arrayOf(PropTypes.oneOf(ADVERTISEMENT_PARTNERS)),
  placement: PropTypes.oneOf(ADVERTISEMENT_PLACEMENTS).isRequired,
  view: PropTypes.oneOf(ADVERTISEMENT_VIEWS).isRequired,
};

AdvertisementAffiliateTileList.defaultProps = {
  partners: ADVERTISEMENT_PARTNERS,
};

export default AdvertisementAffiliateTileList;
